angular.module('unica_workshop.workshop_services')

.factory('WorkshopEditService', function ($http, getBaseApiURL) {

	var workshopEditService = {};

	workshopEditService.update = function (workshopData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop/update/' + workshopData.id,
			data: workshopData
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop;
			}

		});

	};

	return workshopEditService;
});